import {configureStore, createListenerMiddleware, TypedStartListening} from "@reduxjs/toolkit";
import clubsReducer from './reducers/clubs/slice'
import sessionReducer from "./reducers/session/slice";
import postRoundReducer from "./reducers/postRound/slice";
import {useDispatch} from "react-redux";

export const listenerMiddleware = createListenerMiddleware()

export const store = configureStore({
    reducer: {
        session: sessionReducer,
        clubs: clubsReducer,
        postRound: postRoundReducer,
    },
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().prepend(listenerMiddleware.middleware)
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()


// NO IDEA WHAT'S GOING ON
// @see https://redux-toolkit.js.org/api/createListenerMiddleware#typescript-usage
export type AppStartListening = TypedStartListening<RootState, AppDispatch>
// export type AppAddListener = TypedAddListener<RootState, AppDispatch>

export const startAppListening = listenerMiddleware.startListening as AppStartListening
// export const addAppListener = addListener as AppAddListener

